import * as actionTypes from "./actionTypes";
import { JSONInterface } from "../../interfaces/JSONInterface";

export const setJSON = (json: JSONInterface) => {
  return { type: actionTypes.SET_JSON, payload: json };
};

export const setLoaded = (loaded: boolean) => {
  return { type: actionTypes.SET_LOADED, payload: loaded };
};

export const setError = (error: string | null) => {
  return { type: actionTypes.SET_ERROR, payload: error };
};
